export default function (context, val) {
    context.commit('set_system', {tab: val});
}